import React, { Fragment, Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import { connect } from 'react-redux';

import styles from '../common/statusSummary.styles';
import { HealthStatusCount } from '../common/healthStatusCount';
import Modal from '../../../common/modal/Modal';
import Confirm from '../../../common/confirm/Confirm';
import { deleteSiteAccessPointAction } from '../../../../reducers/actions';

class AccessPoints extends Component {
  onDeleteAccessPointConfirm = nodeAddress => {
    let currentSiteId = localStorage.getItem(`airfinder_selected_site`);
    this.props.deleteSiteAccessPoint(currentSiteId, nodeAddress);
    this.props.handleDeleteModal();
  };

  render() {
    const { summary, selectedRowData } = this.props;
    return (
      <Fragment>
        <a
          className={css(styles.cards, styles.cardsAp)}
          href="#/?AP=true "
          style={{
            boxShadow:
              summary.borderColor && summary.borderColor.boxShadow,
            border:
              summary.borderColor && summary.borderColor.border,
            background: this.props.activeBackground
          }}
          onClick={() => this.props.rowDisplay('showAps')}
        >
          <div className={css(styles.fieldHeader)}>
            <div className={css(styles.title)}>
              {I18n.t('accessPointTableHeader.title')}
            </div>
            <span className={css(styles.totalCount)}>
              {summary.totalCount}
            </span>
          </div>
          <HealthStatusCount
            counts={summary.healthStatusCount}
          />
        </a>
        <Modal
          isOpen={this.props.showModal}
          onRequestClose={this.props.handleDeleteModal}
          title={I18n.t('delete.deleteAccessPointLabel')}
        >
          <Confirm
            confirm={() =>
              this.onDeleteAccessPointConfirm(selectedRowData.nodeAddress)
            }
            deny={this.props.handleDeleteClose}
            customValue={(selectedRowData && selectedRowData.nodeAddress) || ''}
            deleteText={I18n.t('delete.confirmDeleteAccessPoint', {
              customValue:
                (selectedRowData && selectedRowData.nodeAddress) || ''
            })}
          />
        </Modal>
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    deleteSiteAccessPoint(currentSiteId, nodeAddress) {
      dispatch(deleteSiteAccessPointAction(currentSiteId, nodeAddress));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(AccessPoints);



// WEBPACK FOOTER //
// ./src/components/data/status/accesspoint/index.js